/**
 * KashIO Core EXT r.1.0.0.a
 * KashIO Core API-EXT Release 1.0.0.alpha
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import {
  HttpClient, HttpEvent, HttpHeaders,
} from '@angular/common/http';

import { isNil } from 'lodash';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfig } from '../_helpers/appconfig.service';
import { BatchFilesDetails, BatchList } from '../_models/batchProcess.interface';

@Injectable()
export class ProcessService {

  public defaultHeaders = new HttpHeaders();
  private _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();
  protected kcmssvcURL = this._kcmssvcURL;

  constructor(
    protected httpClient: HttpClient
  ) { }

  getProcessNew(public_id?: string): Observable<BatchList> {
    return this.httpClient.get<BatchList>(`${this.kcmssvcURL}/batch_files?customer_id=` + public_id);
  }

  public ProcessImport(body: any, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Process Import.');
    }
    let headers = this.defaultHeaders;

    headers.append('Content-Type', 'text/plain');

    return this.httpClient.post<any>(`${this.kcmssvcURL}/batch_files`,
      body,
      {
        observe: 'response'
        , headers: headers

      }
    );

  }//end

  public ProcessImportParse(id: any, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter body was null or undefined when calling Process Import.');
    }
    let headers = this.defaultHeaders;
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return this.httpClient.post(`${this.kcmssvcURL}/batch_files/${encodeURIComponent(String(id))}/confirm`,
      observe,
      {
        observe: 'body',
        headers: headers
      }
    );
  }//end

    public ProcessImportConfirm(file_id: any): Observable<any> {
    if (isNil(file_id)) {
      throw new Error('Required parameter file_id was null or undefined when calling Process Import Confirm.');
    }
    let headers = this.defaultHeaders;
    headers.append('Content-Type', 'application/json');
    const body = {
      file_id: file_id
    };
    return this.httpClient.post(`${this.kcmssvcURL}/kbatch/confirm`,
      body,
      {
        observe: 'body',
        headers: headers
      }
    );
  }//end

  downloadfile(url: string) {
    const headers = new HttpHeaders().set("InterceptorSkipHeader", 'Yes');
    return this.httpClient.get(url,
      {
        headers: headers,
        responseType: 'blob',
        observe: 'response'
      });
  }

  getBatchDetails(batch_id?: string): Observable<BatchFilesDetails> {
    return this.httpClient.get<BatchFilesDetails>(`${this.kcmssvcURL}/batch_files/` + batch_id);
  }

  uploadFileToKbatch(payload: { user_id: string, user_name: string, user_email: string, company_id: string, file_name: string, file_type: string, service_name?: string }): Observable<any> {
    if (!payload || !payload.user_id || !payload.user_name || !payload.user_email || !payload.company_id || !payload.file_name || !payload.file_type) {
      throw new Error('Required parameters are missing.');
    }
    let headers = this.defaultHeaders;
    headers = headers.set('Content-Type', 'application/json');
    
    return this.httpClient.post<any>(`${this.kcmssvcURL}/kbatch/upload-file`, payload, {
      headers: headers,
      observe: 'body'
    });
  }

  uploadFileToPresignedUrl(presignedUrl: string, file: File): Observable<any> {
    if (!presignedUrl || !file) {
      throw new Error('Required parameters are missing.');
    }

    const headers = new HttpHeaders().set("InterceptorSkipHeader", 'Yes');
    
    return this.httpClient.put(presignedUrl, file, {
      headers: headers,
      observe: 'response'
    });
  }
}
